import { FC } from "react";
import { InputProps } from "@chakra-ui/input";
import { Button, HStack, Icon, Input } from "@chakra-ui/react";

import { CrossIcon, SearchIcon } from "../../icons";

interface Props extends InputProps {
  onClear: () => void;
  height?: string;
  placeholder?: string;
}

export const SearchInput: FC<Props> = (props) => {
  const {
    onClear,
    height,
    placeholder,
    value,
    ...otherProps
  } = props;

  const isEmpty = !value || (typeof value === "string" && value.trim() === "");

  return (
    <HStack
      h={height ?? "40px"}
      border="1px solid"
      borderColor="gray.100"
      borderRadius="12px"
      pl="15px"
      bg={isEmpty ? "gray.50" : "transparent"}
    >
      <Icon as={SearchIcon} boxSize="24px" mr="5px" />

      <Input
        h="100%"
        placeholder={placeholder ?? "Поиск"}
        value={value}
        color="brand.500"
        {...otherProps}
        variant="unstyled"
      />

      {value && (
        <Button minW="11px" h="100%" p="6px" mr="8px" onClick={onClear} colorScheme="transparent">
          <Icon as={CrossIcon} boxSize="11px" mt="1px" />
        </Button>
      )}
    </HStack>
  );
};
